import { render, staticRenderFns } from "./ReverseLogisticsAdd.vue?vue&type=template&id=32db4f6e&scoped=true"
import script from "./ReverseLogisticsAdd.vue?vue&type=script&lang=js"
export * from "./ReverseLogisticsAdd.vue?vue&type=script&lang=js"
import style0 from "./ReverseLogisticsAdd.vue?vue&type=style&index=0&id=32db4f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db4f6e",
  null
  
)

export default component.exports